import React from "react";

function WorkFromHomeIcon() {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="16"
			height="16"
			fill="none"
			viewBox="0 0 16 16"
		>
			<g clipPath="url(#clip0_1601_75086)">
				<path
					fill="#8C8594"
					fillRule="evenodd"
					d="M14 13.162V6.029a.81.81 0 00-.397-.69L8.515 2.147a.957.957 0 00-1.018 0l-5.1 3.182a.844.844 0 00-.397.7v7.134c0 .459.41.838.906.838h3.192V9.2h3.75V14h3.246c.497 0 .906-.379.906-.838z"
					clipRule="evenodd"
				/>
			</g>
			<defs>
				<clipPath id="clip0_1601_75086">
					<path fill="#fff" d="M0 0H12V12H0z" transform="translate(2 2)" />
				</clipPath>
			</defs>
		</svg>
	);
}

export default WorkFromHomeIcon;
